"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    avatar: {},
    closeButton: {
      height: 56,
      width: 56
    },
    drawer: {
      width: 328,
      flexShrink: 0
    },
    drawerPaper: _defineProperty({
      width: 328,
      paddingBottom: 66
    }, theme.breakpoints.down(321), {
      width: 276
    }),
    menu: {},
    menuAvatar: {
      marginRight: 16
    },
    menuItemText: {
      color: theme.palette.text.primary,
      width: 200,
      fontSize: 14
    },
    primaryText: {
      color: theme.palette.text.primary,
      width: 200
    },
    secondaryText: {
      color: theme.palette.text.secondary,
      fontSize: 14
    },
    ellipsis: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    logginToAppIcon: {
      marginRight: 24,
      marginLeft: 8,
      padding: 0,
      borderRadius: 'initial',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: 'initial'
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;